import cornerstoneTools from 'cornerstone-tools';
import { getEnabledElement } from '../../../util/state';

export const startMoviePlayer = (selectedIndex) => {
  const element = getEnabledElement(selectedIndex);

  if (!element) return;

  cornerstoneTools.playClip(element, 10);
};

export const stopMoviePlayer = (selectedIndex) => {
  const element = getEnabledElement(selectedIndex);

  if (!element) return;

  cornerstoneTools.stopClip(element);
};
